import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom"
import { router } from "./router"
import { useAutoLogin } from "./modules/auth/lib/login"
import "./fonts/raleway.regular.ttf"
import { initialized } from "./lib/api"
import { useClientConfig } from "./lib/clientConfig";
import { useStoreShared } from "./store";
import { setClientConfig } from "./store/actions";

function App() {
  useAutoLogin()
  const root = document.documentElement;
  // eslint-disable-next-line no-restricted-globals
  const [clientConfigApi, error, loadingList] = useClientConfig({url : location.host })
  const { stateShared, dispatchShared } = useStoreShared()

useEffect(() => {

  if (clientConfigApi.length){
    const clientConfig  = clientConfigApi[0];
    console.log(clientConfig.urlFont)
    if (clientConfig.urlFont ){
          const head = document.head;
          const link = document.createElement("link");
          link.type = "text/css";
          link.rel = "stylesheet";
          link.href = clientConfig.urlFont;
          head.appendChild(link);
    }
      dispatchShared(setClientConfig({
        "login": {
          "logo": clientConfig.loginLogo,
        },
        "header": {
          "backgroundColor": "#"+ clientConfig.headerBackgroundColor ,
          "titleColor":"#"+ clientConfig.headerTitleColor ,
          "logo": clientConfig.headerLogo
        },
        "global": {
          "backgroundColor": "#"+ clientConfig.backgroundColor ,
          "titleColor": "#"+ clientConfig.titleColor ,
          "textColor": "#"+ clientConfig.textColor ,
          "fontFamily": clientConfig.fontFamily,
          "urlFont": clientConfig.urlFont,
        },
        "button": {
          "color": "#"+ clientConfig.buttonColor ,
          "textColor": "#"+ clientConfig.buttonTextColor ,
          "selectedColor": "#"+ clientConfig.buttonSelectedColor ,
          "selectedTextColor": "#"+ clientConfig.buttonSelectedtextColor ,
        },
        "filter": {
          "filterPlayerAllColor": clientConfig.filterPlayerAllColor ,
          "filterPlayerOfflineColor": clientConfig.filterPlayerOfflineColor ,
          "filterPlayerOnlineColor": clientConfig.filterPlayerOnlineColor ,
        },
      }))
    root.style.setProperty('--header-background-color', "#"+clientConfig.headerBackgroundColor );
    root.style.setProperty('--header-title-color', "#"+clientConfig.headerTitleColor );
    root.style.setProperty('--background-color', "#"+clientConfig.backgroundColor);
    root.style.setProperty('--text-color', "#"+clientConfig.textColor);
    root.style.setProperty('--title-color', "#"+clientConfig.titleColor );
    root.style.setProperty('--font-family', clientConfig.fontFamily);
    root.style.setProperty('--button-color', "#"+clientConfig.buttonColor );
    root.style.setProperty('--button-selected-color', "#"+clientConfig.buttonSelectedColor);
    root.style.setProperty('--button-text-color', "#"+clientConfig.buttonTextColor );
    root.style.setProperty('--button-selected-text-color', "#"+clientConfig.buttonSelectedtextColor);
    root.style.setProperty('--filter-player-all-color', "#"+clientConfig.filterPlayerAllColor );
    root.style.setProperty('--filter-player-offline-color', "#"+clientConfig.filterPlayerOfflineColor );
    root.style.setProperty('--filter-player-online-color', "#"+clientConfig.filterPlayerOnlineColor );
  }

}, [clientConfigApi])



  return <main>{initialized ? <RouterProvider router={router} /> : "Loading application..."}</main>
}

export default App
